module.exports = __webpack_public_path__ + "static/media/student_spritemap-64x96.31134e3d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/studentPilot/student_spritemap-64x96.png
// module id = 887
// module chunks = 0